// 1. 외부 패키지


// 2. 프로젝트 내부 alias
import 'swiper/swiper.scss'
import 'swiper/components/pagination/pagination.scss'


// 3. 상대 경로
import LeftCategoryIcon from "./left-category-icon";
import LeftBookMarker from "./left-book-marker";
import LeftImageSlider from "./left-image-slider";


// 4. 타입


const Left = () => {
	return (
		<div className="left rel">
			<LeftCategoryIcon />
			<LeftBookMarker />
			<LeftImageSlider />
		</div>
	);
};

export default Left;